require("./require-signin.scss");

(function($, global) {
    function handleClick($cnt) {
        $.post($cnt.data("url"), { requestUrl: window.location.href })
            .done(function(rsp) {
                if (rsp.updateSaveStatusUrl) {
                    bindResponse($cnt, rsp);
                } else {
                    $.colorbox({ html: rsp });
                    console.log(rsp);
                }
            })
            .fail(function(xhr) {
                console.log("ROBOT: Could not save the item");
            });
    }

    function bindResponse($cnt, rsp) {
        $cnt.data("url", rsp.updateSaveStatusUrl);

        const anchor = $cnt.find("a");
        anchor.toggleClass("saved", rsp.isSaved);
        $.each(anchor,
            function() {
                const $this = $(this);
                if ($this.parents().hasClass("gallery-portal-top")) {
                    $this.attr("data-webm-clickvalue", rsp.isSaved ? "unsave-item" : "save-item");
                } else {
                    $this.attr("data-webm-clickvalue", rsp.isSaved ? "unsave-item-nav" : "save-item-nav");
                }
            });

    }

    function loadStatus($cnt) {
        const url = $cnt.data("url");

        $.get(url)
            .done(function(rsp) {
                bindResponse($cnt, rsp);

                $cnt.click(function() {
                    handleClick($cnt);
                });
            })
            .fail(function(xhr) {
                console.log("ROBOT: Do not know if this item is saved");
            });
    }

    $(function() {
        $("#save_item_components").children().each(function() {
            const elm = $(this);
            $(elm.data("target")).append(elm);
        });

        const control = $(".section-saved-status");
        loadStatus(control);

        $(global).on("EnquirySaveCar",
            function() {
                bindResponse($(control),
                    {
                        updateSaveStatusUrl: $(control).data("url"),
                        isSaved: true
                    });
            });
    });
})(jQuery, window);